import React from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";
import {AgGridColumn as Col, AgGridReact as Grid} from "ag-grid-react";

import {DateRenderer} from "../../../components";
import {caseInsensitiveNameComparator} from "../../../utils";

const Container = styled.div`
    width: 850px;
    height: ${props => props.height}px;
`;

class ReviewsDataGrid extends React.Component {
  onGridReady = ({api}) =>
    api.sizeColumnsToFit();

  reviewerRenderer = ({value}) => (<div><span>{value === '00000000-0000-0000-0000-000000000000' ? '': value}</span></div>);

  render() {
    return (
      <Container height={this.props.height} className='ag-fresh'>
        <Grid
          rowData={this.props.patients}
          onGridReady={this.onGridReady}
          rowHeight={35}
          headerHeight={35}
          pagination={true}
          enableFilter={false}
          enableSorting={false}
          enableColResize={false}
          suppressMovableColumns={true}
          paginationPageSize={this.props.pageSize}
          defaultColDef={{filterParams: {newRowsAction: 'keep'}}}
          columnTypes={{
            actionsColumn: {suppressMenu: true, suppressSorting: true}
          }}
          frameworkComponents={{
            dateRenderer: DateRenderer,
            reviewerRenderer: this.reviewerRenderer,
            actionsRenderer: this.props.actionsRenderer
          }}
        >
          <Col
            sort="asc"
            sortedAt={0}
            field="facilityName"
            headerName="Facility Name"
          />
          <Col
            width={125}
            sortedAt={1}
            sort="asc"
            field="name"
            comparator={caseInsensitiveNameComparator}
            headerName="Patient Name"
          />
          <Col
            width={90}
            headerName="Admit Date"
            field="admissionDate"
            cellRenderer="dateRenderer"
          />
          <Col
            width={85}
            headerName="Review Status"
            field="recordStatus"
          />
          <Col
            width={100}
            headerName="Reviewer"
            field="reviewer"
            cellRenderer="reviewerRenderer"
          />
          <Col
            width={80}
            headerName="Actions"
            type="actionsColumn"
            cellRenderer="actionsRenderer"
          />
        </Grid>
      </Container>
    )
  }
}

ReviewsDataGrid.defaultProps = {
  pageSize: 10,
  height: 425
};

ReviewsDataGrid.propTypes = {
  patients: PropTypes.array.isRequired,
  actionsRenderer: PropTypes.func.isRequired,
  pageSize: PropTypes.number,
  height: PropTypes.number,
};

export default ReviewsDataGrid;



// WEBPACK FOOTER //
// ./src/modules/sample/components/ReviewsDataGrid.js